import { render, staticRenderFns } from "./Glide.vue?vue&type=template&id=3ab97f6b&scoped=true&"
import script from "./Glide.vue?vue&type=script&lang=js&"
export * from "./Glide.vue?vue&type=script&lang=js&"
import style0 from "./Glide.vue?vue&type=style&index=0&id=3ab97f6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ab97f6b",
  null
  
)

export default component.exports